<div *ngIf="isEditEmployeeModalOpen" class="job-card-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="heading-container">
    <p class="heading-title">Add Employee to</p>
    <a href="#" (click)="handleClose(); $event.preventDefault()"
      ><img style="height: 12px; width: 12px" src="/assets/images/icon/close_white.svg"
    /></a>
  </div>
  <div class="modal-container">
    <div class="row text-center mt-5">
      <!-- Left Section -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-6" id="section-left">
        <div class="section-wrapper">
          <label class="label-title">Add Employee to Owner/Facility</label>
          <div class="row">
            <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-10 col-sm-10 col-md-10 col-lg-10">
              <div class="form-group">
                <select class="form-control select2" tabindex="9" formControlName="owner" #owner id="">
                  <option [value]="null" disabled>Select Owner/Facility</option>
                  <option *ngFor="" [value]="">123</option>
                </select>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input type="text" id="owner" (blur)="setDataToControl('owner', owner.value)" />
                </div>
              </div>
            </div>
            <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
          </div>
        </div>
      </div>
      <!-- Right Section -->
      <div class="col-12 col-sm-6 col-md-4 col-lg-6">
        <label class="label-title">Add employee to a specific job</label>
        <div class="row">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-10 col-sm-10 col-md-10 col-lg-10">
            <div class="form-group">
              <select class="form-control select2" tabindex="9" formControlName="owner" #owner id="">
                <option [value]="null" disabled>Select Owner/Facility</option>
                <option *ngFor="" [value]="">123</option>
              </select>
              <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                <input type="text" id="owner" (blur)="setDataToControl('owner', owner.value)" />
              </div>
            </div>
          </div>
          <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
        </div>
        <div class="row my-3">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-10 col-sm-10 col-md-10 col-lg-10">
            <div class="form-group">
              <select class="form-control select2" tabindex="9" formControlName="job" #job id="">
                <option [value]="null" disabled>Select Job</option>
                <option *ngFor="" [value]="">123</option>
              </select>
              <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                <input type="text" id="job" (blur)="setDataToControl('job', job.value)" />
              </div>
            </div>
          </div>
          <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="btn btn-outline-primary" (click)="handleClose(); $event.preventDefault()">Cancel</button>
      <button class="btn btn-primary" (click)="handleAdd('add')">Add</button>
    </div>
  </div>
</div>
